var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('sorts',{staticClass:"content-sorting",attrs:{"inputs":_vm.updatedSorts,"extendButton":false,"sorts":_vm.defaultSelected,"columns":12,"forceUpdate":true},on:{"sorting":_vm.sortContent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }